import Layout from "@/components/Layout";
import Hero from "@/components/Hero";
import Immersion from "@/components/Immersion";
import Transition from "@/components/Transition";
import ReleaseComingSoon from "@/components/ReleaseComingSoon";
import Tickets from "@/components/Tickets";
import EventTrailer from "@/components/EventTrailer";
import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";

/**
 * Chapter II — the Limited Edition Print Release.
 * The full cinematic landing page. Wrapped in the site Layout so the
 * fixed Header/Footer are present (Header overlays the hero with
 * mix-blend-difference for legibility).
 *
 * The live Release grid (Release.jsx — pricing, Stripe, inventory) is
 * temporarily replaced by the ReleaseComingSoon placeholder while titles,
 * editions and pricing are finalised. The backend remains intact.
 */
export default function ChapterII() {
  return (
    <Layout>
      <main data-testid="chapter-ii-page" className="bg-[color:var(--bone)]">
        <Hero />
        <EventTrailer testid="chapter-ii-trailer" />
        <Immersion />
        <Tickets />
        <Transition />
        <ReleaseComingSoon />

        {/* Quiet closing strip (the global Footer takes the closing role) */}
        <section
          className="dark-section py-32 md:py-48"
          data-testid="chapter-ii-closing"
        >
          <div className="max-w-[1100px] mx-auto px-6 md:px-12 text-center md:text-right">
            <Reveal slow>
              <p className="font-serif italic text-3xl md:text-5xl leading-[1.1]">
                Chapter II will not remain open indefinitely.
              </p>
              <p className="font-serif italic text-5xl md:text-7xl mt-12 md:mt-16">
                Nick Fraser
              </p>
              <p className="hairline opacity-50 mt-3">1946 — 2023</p>
              <Link
                to="/collector"
                className="link-quiet font-serif italic text-lg mt-12 inline-block"
                data-testid="chapter-ii-collector-link"
              >
                For collectors →
              </Link>
            </Reveal>
          </div>
        </section>
      </main>
    </Layout>
  );
}
